import type { AdminDashboardExpenseCategoryRow } from "@/admin/entities/adminDashboard";
import { INTERNAL_EXPENSE_CATEGORY_LABEL } from "@/admin/entities/internalExpenses";
// Напрямую из routes: баррель тянет config с import.meta, который не собирается в jest.
import { PagePaths } from "@/admin/shared/constants/routes";
import type { DayRange } from "./periodPresets";

export interface ExpenseCategoryTableRow {
  category: string;
  label: string;
  amountUSD: number;
  count: number;
  /** Доля от всех трат периода, %; null, если трат нет. */
  share: number | null;
}

const round1 = (value: number) => Math.round(value * 10) / 10;
const money = (value: number) => Math.round(value * 100) / 100;

/** Таблица «Траты за период» (спека §3.6), статьи по-русски. */
export function buildExpenseCategoryRows(
  rows: AdminDashboardExpenseCategoryRow[]
): ExpenseCategoryTableRow[] {
  const total = rows.reduce((sum, row) => sum + row.amountUSD, 0);
  return rows.map((row) => ({
    category: row.category,
    label: INTERNAL_EXPENSE_CATEGORY_LABEL[row.category] ?? row.category,
    amountUSD: row.amountUSD,
    count: row.count,
    share: total > 0 ? round1((row.amountUSD / total) * 100) : null,
  }));
}

export function expenseCategoryTotals(
  rows: AdminDashboardExpenseCategoryRow[]
): {
  amountUSD: number;
  count: number;
} {
  return {
    amountUSD: money(rows.reduce((sum, row) => sum + row.amountUSD, 0)),
    count: rows.reduce((sum, row) => sum + row.count, 0),
  };
}

/**
 * «Все траты» с фильтром периода. Список трат читает фильтр из
 * `?filter=` (CRUD) и приводит даты к началу и концу дня в часовом поясе
 * браузера (expensesSchemas.normalizeFilter), поэтому даты уходят
 * полднем UTC: в любом поясе от UTC-12 до UTC+12 это тот же
 * календарный день.
 */
export function expensesHref(range: DayRange): string {
  const filter = JSON.stringify({
    dateFrom: `${range.from}T12:00:00.000Z`,
    dateTo: `${range.to}T12:00:00.000Z`,
  });
  return `${PagePaths.billingExpenses}?filter=${encodeURIComponent(filter)}`;
}
